import { render, staticRenderFns } from "./AddFields.vue?vue&type=template&id=b9a80934&scoped=true"
import script from "./AddFields.vue?vue&type=script&lang=js"
export * from "./AddFields.vue?vue&type=script&lang=js"
import style0 from "./AddFields.vue?vue&type=style&index=0&id=b9a80934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a80934",
  null
  
)

export default component.exports